module.exports = __webpack_public_path__ + "img/2.15c822c2.jpeg";